var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"w-1/2"},[(_vm.audit)?_c('h1',[_vm._v("Audit Overview page for "+_vm._s(_vm.audit.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }